// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"195":"b310bdec25069f3442c1","294":"73db615a50ed9a669f6c","501":"cfee42573f1afe4d74b9","846":"41e6972fbc56c7501dea","967":"879c475a8cd71f0920a0"}[chunkId] + ".js";
};